export type { FilteringStyledOptions, StyledComponent, StyledOptions } from '@emotion/styled';
export * from './assets';
export * from './components';
export * from './constants';
export * from './system';
export * from './theme';
export * from './types';
export * from './utils';

const originalError = console.error;

console.error = (...args) => {
  if (
    process.env.NODE_ENV === 'development' &&
    typeof args[0] === 'string' &&
    args[0].includes(
      'If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase',
    )
  ) {
    return;
  }
  originalError(...args);
};
